// authConfig.js

import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: 'e81ff375-0dbb-4eb4-ab54-a438d8cc7aa0',
        authority: 'https://login.microsoftonline.com/7f8244b8-3a28-4d97-88c4-4d7c1c73617a',
        redirectUri: process.env.REACT_APP_AUTH_CALLBACK, // your redirect URI
    },
    cache: {
        cacheLocation: 'localStorage', // or 'localStorage'
        storeAuthStateInCookie: true,
    },
};
const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
